import React from "react";

const INPUT_BASE_CLASS =
  "h-11 w-full rounded-xl border border-gray-200 bg-white px-4 text-sm font-inter text-gray-900 outline-none transition-colors placeholder:text-gray-400 focus:border-primary-blue";

export default function EmailConfigField({
  label,
  type = "text",
  value,
  onChange,
  placeholder,
  className = "",
  children,
}) {
  return (
    <label className={`flex flex-col gap-2 text-sm ${className}`}>
      <span className="font-inter text-xs font-medium uppercase tracking-wider text-gray-500">
        {label}
      </span>
      {children ? (
        children
      ) : (
        <input
          type={type}
          value={value}
          onChange={onChange}
          className={INPUT_BASE_CLASS}
          placeholder={placeholder}
        />
      )}
    </label>
  );
}

export { INPUT_BASE_CLASS };
